<template>
  <list class="business-hours-list"
        :list="list"
        :infiniteId="infiniteId"
        :headers="headers"
        :loading="loading"
        @load="load">
    <template slot="default"
              slot-scope="slotProps">
      <business-hours-list-item :item="slotProps.item"
                                  @reload="emitReload"/>
    </template>
  </list>
</template>

<script>
import List from "@components/generic/list/List.vue";
import BusinessHoursListItem from "./item/BusinessHoursListItem.vue";

export default {
    components: {
    List,
    BusinessHoursListItem,
},

    data() {
      return {
        loading: false,
        list: [],
        daysOfWeek: [
          "SUNDAY",
          "MONDAY",
          "TUESDAY",
          "WEDNESDAY",
          "THURSDAY",
          "FRIDAY",
          "SATURDAY"
        ]
      };
    },


    props: {
      infiniteId: {
        type: Number,
        required: true,
      },
    },

    computed: {
        headers() {
            return [
                {text: "", value: "", sortable: false, width: "5px"},
                { text: this.$t('message.businessHours.message.dayOfWeek'), value: "dayOfWeek", sortable: false },
                { text: this.$t('message.businessHours.message.openingTime'), value: "openingTime", sortable: false },
                { text: this.$t('message.businessHours.message.closingTime'), value: "closingTime", sortable: false },
                { text: this.$t('message.businessHours.message.limitToBusinessHours'), value: "limitCaptiveToPeriod", sortable: false, width: "15px" },
                {text: "", value: "", sortable: false, width: "5px"},
            ]
        },

    },

    methods: {
      async load($state) {
        try {
          const businessHoursList = await this.$api.core.businessHours.list()

          this.list = businessHoursList.sort((a,b) => {
            return this.daysOfWeek.indexOf(a.dayOfWeek) - this.daysOfWeek.indexOf(b.dayOfWeek)
          });          

          $state.complete();
        } catch (error) {
          console.log(error);
        }
      },
      emitReload() {
        this.$emit("reload");
      },

    },
    mounted() {
      const headerItem = document.querySelector('th[width="15px"]')
      const customImg = document.createElement('img')
      customImg.setAttribute('class', 'custom-img')
      customImg.src = '/images/help-circle-outline-custom.png'
      headerItem.appendChild(customImg)
    }

  };
</script>

<style lang="scss" scoped>
@import "~@variables";

  .business-hours-list {
    ::v-deep .v-table__overflow {
      overflow: visible;
    }

    ::v-deep th[width="15px"] {
      cursor: pointer;
    }

    ::v-deep th[width="15px"] .custom-img {
      margin-left: 5px;
      vertical-align: middle;
    }

    ::v-deep th[width="15px"]::before {
      content: "  Caso habilitado, o acesso só será permitido\A durante o horário de funcionamento da empresa.";
      white-space: pre;
      width: 370px;
      padding: 10px 5px;
      opacity: 1;
      background-color: white;
      position: absolute;
      z-index: 500;
      border: 1px solid #c8c8c8;
      border-radius: 20px 0 20px 20px;
      margin-top: 25px;
      margin-left: -100px;
      display: none;
    }

    ::v-deep th[width="15px"]::after {
      content: "";
      width: 0;
      height: 0;
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-bottom: 5px solid $primary;
      position: absolute;
      z-index: 999;
      margin-left: -14px;
      margin-top: 25px;
      transform: translateX(-50%) rotate(45deg);
      visibility: hidden;
    }

    ::v-deep th[width="15px"]:hover::before {
      display: inline-block;
    }

    ::v-deep th[width="15px"]:hover::after {
      visibility: visible;
    }
  }

</style>
